// Angular imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AngularSplitModule } from 'angular-split';

// CC-Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

// devextreme module imports
import {
    DxBoxModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxContextMenuModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDropDownBoxModule,
    DxFormModule,
    DxLoadPanelModule,
    DxNumberBoxModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxSwitchModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule
} from 'devextreme-angular';

// module imports
import { SharedModule } from '../shared-module/shared.module';
import { ManagementCommonModule } from '../management-common/management-common.module';

// component imports
import { WorkflowNotesEditorComponent } from './components/workflow-notes-editor/workflow-notes-editor.component';
import { WorkflowInvoiceViewerComponent } from './components/workflow-invoice-viewer/workflow-invoice-viewer.component';
import { WorkflowReclassifyComponent } from './components/workflow-reclassify/workflow-reclassify.component';
import { WorkflowJobDetailsComponent } from './components/workflow-job-details/workflow-job-details.component';
import { WorkflowInvoiceLineItemsEditorComponent } from './components/workflow-invoice-line-items-editor/workflow-invoice-line-items-editor.component';
import { WorkflowBoardNotesEditorComponent } from './components/workflow-board-notes-editor/workflow-board-notes-editor.component';
import { WorkflowHistoryComponent } from './components/workflow-history/workflow-history.component';
import { WorkflowInvoiceHeaderDetailsViewerComponent } from './components/workflow-invoice-header-details-viewer/workflow-invoice-header-details-viewer.component';
import { WorkflowIvaHistoryComponent } from './components/workflow-iva-history/workflow-iva-history.component';
import { WorkflowPaymentHistoryComponent } from './components/workflow-payment-history/workflow-payment-history.component';
import { WorkflowNotesViewerComponent } from './components/workflow-notes-viewer/workflow-notes-viewer.component';
import { WorkflowVendorNotesComponent } from './components/workflow-vendor-notes/workflow-vendor-notes.component';
import { WorkflowViewerComponent } from './components/workflow-viewer/workflow-viewer.component';
import { WorkflowDetailViewerComponent } from './components/workflow-detail-viewer/workflow-detail-viewer.component';
import { WorkflowInvoiceLineItemsViewerComponent } from './components/workflow-invoice-line-items-viewer/workflow-invoice-line-items-viewer.component';
import { WorkflowInvoiceHeaderDetailsEditorComponent } from './components/workflow-invoice-header-details-editor/workflow-invoice-header-details-editor.component';
import { WorkflowStatusLinkComponent } from './components/workflow-status-link/workflow-status-link.component';
import { WorkflowChecklistEditorComponent } from './components/workflow-checklist-editor/workflow-checklist-editor.component';
import { WorkflowBoardApprovalViewerComponent } from './components/workflow-board-approval-viewer/workflow-board-approval-viewer.component';
import { WorkflowCodingDefaultComponent } from './components/workflow-coding-default/workflow-coding-default.component';
import { WorkflowStatusBreadcrumbComponent } from './components/workflow-status-breadcrumb/workflow-status-breadcrumb.component';
import { WorkflowInvoiceHeaderEditorComponent } from './components/workflow-invoice-header-editor/workflow-invoice-header-editor.component';
import { WorkflowInvoiceReclassifyHeaderDetailsComponent } from './components/workflow-invoice-reclassify-header-details/workflow-invoice-reclassify-header-details.component';

@NgModule({
    declarations: [
        WorkflowNotesEditorComponent,
        WorkflowInvoiceViewerComponent,
        WorkflowReclassifyComponent,
        WorkflowJobDetailsComponent,
        WorkflowInvoiceLineItemsEditorComponent,
        WorkflowBoardNotesEditorComponent,
        WorkflowHistoryComponent,
        WorkflowInvoiceHeaderDetailsViewerComponent,
        WorkflowIvaHistoryComponent,
        WorkflowPaymentHistoryComponent,
        WorkflowNotesViewerComponent,
        WorkflowVendorNotesComponent,
        WorkflowViewerComponent,
        WorkflowDetailViewerComponent,
        WorkflowInvoiceLineItemsViewerComponent,
        WorkflowInvoiceHeaderDetailsEditorComponent,
        WorkflowStatusLinkComponent,
        WorkflowChecklistEditorComponent,
        WorkflowBoardApprovalViewerComponent,
        WorkflowCodingDefaultComponent,
        WorkflowStatusBreadcrumbComponent,
        WorkflowInvoiceHeaderEditorComponent,
        WorkflowInvoiceReclassifyHeaderDetailsComponent
    ],
    imports: [
        CommonModule,
        DxPopupModule,
        DxBoxModule,
        DxLoadPanelModule,
        DxContextMenuModule,
        DxButtonModule,
        DxFormModule,
        DxDataGridModule,
        DxDropDownBoxModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxNumberBoxModule,
        DxSwitchModule,
        DxTextBoxModule,
        DxTextAreaModule,
        DxScrollViewModule,
        DxToolbarModule,
        DxCheckBoxModule,
        DxRadioGroupModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        ManagementCommonModule,
        AngularSplitModule,
        SharedModule
    ],
    exports: [
        WorkflowNotesEditorComponent,
        WorkflowNotesViewerComponent,
        WorkflowInvoiceViewerComponent,
        WorkflowReclassifyComponent,
        WorkflowBoardNotesEditorComponent,
        WorkflowHistoryComponent,
        WorkflowPaymentHistoryComponent,
        WorkflowIvaHistoryComponent,
        WorkflowViewerComponent,
        WorkflowVendorNotesComponent,
        WorkflowJobDetailsComponent,
        WorkflowInvoiceHeaderDetailsEditorComponent,
        WorkflowStatusLinkComponent,
        WorkflowChecklistEditorComponent,
        WorkflowStatusBreadcrumbComponent,
        WorkflowBoardApprovalViewerComponent,
        WorkflowInvoiceHeaderEditorComponent,
        WorkflowInvoiceReclassifyHeaderDetailsComponent
    ]
})
export class SharedWorkflowModule {}
